class DrawerUpsellProduct extends HTMLElement {
    constructor() {
      super();   
      this.atcButton = this.querySelector('button');
      this.upsellProductClose = this.querySelector('.drawer-upsell-product__close');

      this.atcButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.upsellFormSubmit();
      });

      this.upsellProductClose.addEventListener('click', (e) => {
        this.style.display = 'none';
      })
      
      this.inputs = this.querySelectorAll('input');
      this.options = this.querySelectorAll('.ProductForm__Option select option');
      // this.onInputClick();
    }

    onInputClick(){
      let self = this;
      self.inputs.forEach(input => {
        input.addEventListener('click', () => {
          let loopIndex = input.dataset.loopIndex;
          self.atcButton.dataset.productId = self.options[loopIndex].value;
        })
      });
    }
  
    upsellFormSubmit(evt){
      let self = this;
      let productId = this.atcButton.getAttribute('data-product-id');
      let formData = {
        'items': [{
         'id': productId,
         'quantity': 1
         }]
       };
       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
         return response.json();
       })
       .catch((error) => {
         console.error('Error:', error);
       });
    }
  }
  
  customElements.define('drawer-upsell-product', DrawerUpsellProduct);
  